import gql from "graphql-tag"

import CompanyNewsTileFragment from "../fragments/CompanyNewsTile"
import LayoutWidgetsFragment from "../fragments/LayoutWidgets"

const query = gql`
  query TenantHomePage($isNative: Boolean!, $tenantId: String!) {
    companyNews(tenantId: $tenantId) {
      ...CompanyNewsTileFragment
    }
    layoutWidgets(tenantId: $tenantId) @skip(if: $isNative) {
      ...LayoutWidgetsFragment
    }
  }

  ${CompanyNewsTileFragment}
  ${LayoutWidgetsFragment}
`

export const toString = query.loc.source.body

export default query
